// extracted by mini-css-extract-plugin
export default {"title":"x3JqqNIMReInPr08sBCg","container":"RlRmkD6tyX1MB4dSR4Mk","grid":"XWNFD603JsgdO0XbOhVk"};